import styled from 'styled-components'
import Table, { TableFilter } from '../../../myTable/MyTable'
import { THead } from '../indicators-signals-table/IndicatorsSignalTable'
import {
  Empty,
  InterpretationsBody,
  InterpretationsHead,
  NothingFound,
} from './tableComponents'
import { useState, useEffect } from 'react'
import { useAppSelector } from '../../../../hooks/redux'
import { MAX_PER_PAGE } from '../../../../constants/other'
import { getSubjectId } from '../../../../pages/biomarkers/[id]/IndicatorsAndSignals'
import {RightSide} from "../../../../pages/subjects/Subject.style";
import { getLocalizedText } from '../../../../utils/localize'

export const TableStyle = styled.div<{ hasdata: string }>`
  width: 100%;
  display: flex;

  /* height: 600px; */
  /* min-height: 500px; */
  //overflow:scroll;

  ${({ hasdata }) =>
    hasdata === 'true' && 'border: 1px solid var(--border-main, #ededed);'}

  table {
    /* height: 100%; */
    /* table-layout: fixed; */
    width: 100%;
    border: none;
    border-collapse: collapse;

    td {
      border: none;
      vertical-align: middle;
      /* height: fit-content; */

      p {
      }
    }
  }
`

const InterpretationMainTable = (props:any) => {
  const { interpretations, isLoading } = useAppSelector((state) => state.data)
  const { language = 'en' } = props

  let [filter, setFilter] = useState({
    sort: '_id',
    perPage: 1000,
    search: '',
    direction: '_id',
    page: 1,
    filter: { subjectIds: '' }
  })

  // Обновляем subjectIds после инициализации компонента
  useEffect(() => {
    const subjectId = getSubjectId()
    if (subjectId && filter.filter.subjectIds !== subjectId) {
      setFilter(prev => ({
        ...prev,
        filter: { ...prev.filter, subjectIds: subjectId }
      }))
    }
  }, [])

  // API URL для получения интерпретаций с пагинацией
  const apiUrl = `/api/core/theme/interpretation`

  const hasdata = Object.values(interpretations).length > 0 ? 'true' : 'false'

  return (<>
    <TableFilter filter={filter} setFilter={setFilter}
                 name={'Create New Disease'}
                 url={'/' + getSubjectId() + '/diseases/create-diseases'}
    ></TableFilter>
    <TableStyle hasdata={hasdata}>
      <Table
        apiUrl={apiUrl}
        Head={InterpretationsHead}
        Body={(props: any) => <InterpretationsBody {...props} language={language} />}
        EmptyItems={Empty}
        onConnect={props.onConnect}
        connectIds={props.connectIds}
        NothingFound={NothingFound}
        apiSearchFileds={['name']}
        onFilter={(it: any, filter: any) => {
          if (filter._id) {
            return it._id == filter._id
          }
          return true
        }}
        onSearch={(it: any, reg: RegExp) => reg.test(getLocalizedText(it.name, language))}
        onChangeFilter={(v: any) => {
          setFilter(v)
        }}
        filter={filter}
        items={Object.values(interpretations)}
      />
    </TableStyle>
      </>
  )
}

export default InterpretationMainTable
